/**
 * Wrapper around clearInterval that strongly types returned value.
 */
export function clearInterval(timeoutId: number | NodeJS.Timeout): void {
    // tslint:disable-next-line no-typeof-undefined
    if (typeof timeoutId !== "number") {
        global.clearInterval(timeoutId);
    } else {
        window.clearInterval(timeoutId);
    }
}
